module.exports = __webpack_public_path__ + "assets/chat_outline-a17fc3.svg";